import { render, staticRenderFns } from "./ProjectViewWhitelist.vue?vue&type=template&id=5a7840da&scoped=true&"
import script from "./ProjectViewWhitelist.vue?vue&type=script&lang=js&"
export * from "./ProjectViewWhitelist.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewWhitelist.vue?vue&type=style&index=0&id=5a7840da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7840da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDialog,VIcon,VSpacer})
